import { type IssueTypeAttachment } from "@overmap-ai/common"
import { selectIssueTypeAttachmentById } from "@overmap-ai/core"
import type { NodeViewProps } from "@tiptap/react"
import { memo } from "react"

import { sdk } from "../../../sdk"
import { useAppSelector } from "../../../store"
import { BaseAttachmentNodeComponent } from "../BaseAttachment/Component"
import { NotFoundAttachmentNode } from "../BaseAttachment/FallbackAttachmentNode"

export const IssueTypeAttachmentNodeComponent = memo((props: NodeViewProps) => {
	const { node } = props
	const attachmentId = node.attrs.uuid as string
	const issueTypeAttachment = useAppSelector(selectIssueTypeAttachmentById(attachmentId))

	if (!issueTypeAttachment) {
		return <NotFoundAttachmentNode {...props} />
	}

	return (
		<BaseAttachmentNodeComponent<IssueTypeAttachment>
			attachment={issueTypeAttachment}
			service={sdk.issueTypeAttachments}
			{...props}
		/>
	)
})
IssueTypeAttachmentNodeComponent.displayName = "IssueTypeAttachmentNodeComponent"
